module.exports = __webpack_public_path__ + "img/vertical_6_5_7016.07997301.png";